import React, { createContext, useContext, useState } from 'react';

const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
    const [current, setCurrent] = useState('home');
    const [theme, setTheme] = useState('Light');

    return (
        <MenuContext.Provider value={{ current, setCurrent, theme, setTheme }}>
            {children}
        </MenuContext.Provider>
    );
};

export const useMenu = () => useContext(MenuContext);
